import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ContactCTABlock from '../components/ContactCTABlock';
import { faqRoutes, FAQ_CATEGORY_ORDER } from '../content/faqContent';
import { faqCategoryId } from '../utils/faqCategoryId';
import '../styles/FAQ.css';

function FAQ() {
  const { hash } = useLocation();

  const byCategory = faqRoutes.reduce((acc, route) => {
    if (!acc[route.category]) acc[route.category] = [];
    acc[route.category].push(route);
    return acc;
  }, {});

  useEffect(() => {
    if (!hash) return;

    const id = decodeURIComponent(hash.replace(/^#/, ''));
    const scrollToCategory = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    // Wait a tick so layout (and sticky header offset) is ready
    const timer = window.setTimeout(scrollToCategory, 50);
    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <div className="faq-page">
      <section className="faq-hero">
        <div className="faq-hero-content">
          <h1>Frequently Asked Questions</h1>
          <p>Quick answers about personal injury, premises liability, workplace injuries, estate planning, and real estate law matters in Georgia.</p>
        </div>
      </section>

      <section className="faq-content">
        <div className="faq-container">
          {FAQ_CATEGORY_ORDER.map((category) => {
            const routes = byCategory[category];
            if (!routes || routes.length === 0) return null;
            const categoryId = faqCategoryId(category);
            return (
              <div key={category} id={categoryId} className="faq-category">
                <h2>{category}</h2>
                <div className="faq-grid">
                  {routes.map(({ slug, title, category: cardCategory }) => (
                    <Link
                      key={slug}
                      to={`/faq/${slug}`}
                      className="faq-card"
                    >
                      <span className="faq-card-category">{cardCategory}</span>
                      <h3>{title}</h3>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <ContactCTABlock />
    </div>
  );
}

export default FAQ;
